import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/Global/Global.css';
import App from './Global/MainApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot( document.getElementById('root') as HTMLElement );
root.render(
  <React.StrictMode>
    <link href="https://fonts.googleapis.com/css2?family=Playwrite+IT+Moderna:wght@100..400&family=Satisfy&display=swap" rel="stylesheet"/>
    {/* @ts-ignore */}
    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5619224767870187" crossorigin="anonymous"/>
    <App />
  </React.StrictMode>
);

reportWebVitals();
